<div class="notification__image-wrapper">
  <pp-icon class="notification__image" [ppSrc]="EIconPath.NOTIFICATION_ICON_DESCRIPTION" ppColor="primary-950"></pp-icon>
</div>

<span>
  @if (ppNotification.changeBody.newValue && !ppNotification.changeBody.oldValue) {
    <span
      class="notification__blue-text"
      >{{ 'set' | ppTranslate }}</span
      >
    }
    @if (ppNotification.changeBody.newValue && ppNotification.changeBody.oldValue) {
      <span
        class="notification__blue-text"
        >{{ 'changed' | ppTranslate }}</span
        >
      }
      @if (!ppNotification.changeBody.newValue && !ppNotification.changeBody.oldValue) {
        <span
          class="notification__blue-text"
          >{{ 'cleared' | ppTranslate }}</span
          >
        }

        {{ 'the' | ppTranslate }}
        <span class="notification__bold">{{ ppNotification.changeBody.label }}</span>
        {{ 'of_a_point_you' | ppTranslate }}
        {{ notificationReason }}.
      </span>
